var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vx-col w-full"},[_c('div',{staticClass:"p-2 code-color-1 inline-block hand redondo",on:{"click":function($event){return _vm.f_array_voices()}}},[_c('img',{attrs:{"src":require("./volume.svg"),"height":"15px"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }